export enum RemoteAppConfigKeys {
  GoalMetricTemplates = 'goalMetricTemplates',
}

export type RemoteAppConfig = {
  [RemoteAppConfigKeys.GoalMetricTemplates]: string; // MetricTemplate[];
};
